// Default visibility per requirements (true = default column)
export const candidatePayPackagesColumnVisibility = {
  emailIcon: true,
  placementId: true,
  orderId: true,
  placementStatus: true,
  amnDivisionType: true,
  placementStartDate: false,
  placementEndDate: false,
  skillSet: true,
  scenarioStatus: true,
  grossMargin: true,
  grossProfit: false,
  negotiatedContributionMargin: false,
  weeklyGrossPay: true,
  travelerId: false,
  candidateName: false,
  packageName: true,
  bookingPeriodStartDate: true,
  bookingPeriodEndDate: true,
  bookingPeriodDuration: true,
  tla: false,
  scenarioId: true,
  scenarioName: true,
  createdDateAt: false,
  createdByName: false,
  approvedDateAt: false,
  approvedByName: false,
  verifiedDateAt: false,
  verifiedByName: false,
  numberOfSplits: true,
  totalBonuses: true,
  totalReimbursements: true,
  splitId: true,
  splitStartDate: true,
  splitEndDate: true,
  weeklyGrossPaySplit: true,
  billRate: true,
  vms: false,
  other: false,
  payRate: true,
  shift: true,
  hoursPerWeek: false,
  hoursPerShift: false,
  lodgingPerDiem: true,
  mealPerDiem: true,
  housingType: false,
  updatedDateAt: true,
  updatedByName: true,
};

export const defaultColumnOrder = [
  'emailIcon',
  'placementId',
  'orderId',
  'placementStatus',
  'amnDivisionType',
  'placementStartDate',
  'placementEndDate',
  'skillSet',
  'scenarioStatus',
  'grossMargin',
  'grossProfit',
  'negotiatedContributionMargin',
  'weeklyGrossPay',
  'packageName',
  'bookingPeriodStartDate',
  'bookingPeriodEndDate',
  'bookingPeriodDuration',
  'tla',
  'scenarioId',
  'scenarioName',
  'createdDateAt',
  'createdByName',
  'approvedDateAt',
  'approvedByName',
  'verifiedDateAt',
  'verifiedByName',
  'numberOfSplits',
  'totalBonuses',
  'totalReimbursements',
  'splitId',
  'splitStartDate',
  'splitEndDate',
  'weeklyGrossPaySplit',
  'billRate',
  'vms',
  'other',
  'payRate',
  'shift',
  'hoursPerWeek',
  'hoursPerShift',
  'lodgingPerDiem',
  'mealPerDiem',
  'housingType',
  'updatedDateAt',
  'updatedByName',
];
